export default {
    title: 'unorderedList',
    action: [ 'insertUnorderedList' ],
    description: 'Bullet List',
    icon: 'Ul',
};
